import { ActionTypes } from "../../constants/ActionTypes";
import { ISideNavReducer } from "../../interfaces/SideNav";

const initialSettings: ISideNavReducer = {
  navCollapsed: true,
};

const sideNav = (state = initialSettings, action: any) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        navCollapsed: false,
      };

    case ActionTypes.TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.navCollapsed,
      };

    default:
      return state;
  }
};

export default sideNav;
